import { useQuery } from '@tanstack/react-query';
import {
  budgetTeacherPartialInfoApi,
  BUDGET_TEACHER_PARTIAL_TYPE,
} from '@/features/reports/api/budgetTeacherPartialInfo.api';
import type { EmploymentType } from '@/features/reports/data/teacherEquityMock';

export const budgetTeacherPartialInfoQueryKeys = {
  all: ['budget', 'budget-teacher-partial-info'] as const,
  detail: (budgetId: string, type: number) =>
    [...budgetTeacherPartialInfoQueryKeys.all, budgetId, type] as const,
};

function budgetTeacherTypeForEmployment(employmentType: EmploymentType): number {
  return employmentType === 'permanent'
    ? BUDGET_TEACHER_PARTIAL_TYPE.permanent
    : BUDGET_TEACHER_PARTIAL_TYPE.contractual;
}

/**
 * Budget teacher grid for drill-down. GET /api/app/budget/{budgetId}/budget-teacher-partial-info?type=…
 */
export function useBudgetTeacherPartialInfoQuery(
  budgetId: string | null | undefined,
  employmentType: EmploymentType,
  enabled: boolean
) {
  const id = typeof budgetId === 'string' ? budgetId.trim() : '';
  const type = budgetTeacherTypeForEmployment(employmentType);
  const ok = Boolean(enabled && id);

  return useQuery({
    queryKey: ok ? budgetTeacherPartialInfoQueryKeys.detail(id, type) : ['budget-teacher-partial-info', 'off'],
    queryFn: () => budgetTeacherPartialInfoApi.getBudgetTeacherPartialInfo(id, type),
    enabled: ok,
    staleTime: 60 * 1000,
    retry: false,
  });
}
